import React, { createContext, useRef, useState, useEffect } from 'react';
import axios from 'axios'; 

import StreamingAvatar from '@heygen/streaming-avatar';

import {AvatarQuality,StreamingEvents,VoiceChatTransport,VoiceEmotion,StartAvatarRequest,    STTProvider,ElevenLabsModel,} from "@heygen/streaming-avatar";

const AppContext = createContext();

const AppProvider = ({ children }) => {

    const [debug, setDebug] = useState();
    const [initialized, setInitialized] = useState(false);
    const avatar = useRef(null);
    const [avatarId, setAvatarId] = useState("Wayne_20240711");
    const [voiceId, setVoiceId] = useState("0ebe70d83b2349529e56492c002c9572");
    const [data, setData] = useState();
    const [videoObj, setVideoObj] = useState(null);
    const [stream, setStream] = useState();
    const [play, setPlay] = useState(false);
    
    function getServerUrl(path) {
        return `${window.location.protocol}//${window.location.hostname}:${443}${path}`;
    }

    async function fetchAvatarList() {
        try {
            const url = getServerUrl('/get-avatar-list'); 
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            const list = response.data; 
            return list;
        } catch (error) {
            if (error.response) {
                console.error('Error fetching avatar list:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error:', error.message);
            }
            return '';
        }
    };

    async function fetchAccessToken() { 

        try {
            const url = getServerUrl('/get-access-token'); 
            const response = await axios.post(url, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const token = response.data.token; 
            return token;
        } catch (error) {
            if (error.response) {
                console.error('Error fetching access token:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error:', error.message);
            }
            return '';
        }
    };

    const startTalkCallback = (e) => {
        console.log("startTalkCallback: ")
    };

    const stopTalkCallback = (e) => {
        console.log("stopTalkCallback: ")
    };

    async function updateToken() {

        const token = await fetchAccessToken();  

        try {
            avatar.current = new StreamingAvatar({
                token
            }); 
            setInitialized(true); // ✅ Only set after start completes
        } catch (err) {
            console.error('Error updateToken:', err);
        }


        
    }
 
    
    function addEventsOnAvatar(avatar) {
        console.log('addEventsOnAvatar:', avatar);
        avatar.off(StreamingEvents.AVATAR_START_TALKING).on(StreamingEvents.AVATAR_START_TALKING, (event) => {
            console.log('Avatar has started talking:', event);
            // You can update the UI to reflect that the avatar is talking
            startTalkCallback();
        });

        avatar.off(StreamingEvents.AVATAR_STOP_TALKING).on(StreamingEvents.AVATAR_STOP_TALKING, (event) => {
            console.log('Avatar has stopped talking:', event);
            // You can reset the UI to indicate the avatar has stopped speaking
            stopTalkCallback();
        });

        avatar.off(StreamingEvents.AVATAR_TALKING_MESSAGE).on(StreamingEvents.AVATAR_TALKING_MESSAGE, (message) => {
            console.log('Avatar talking message:', message);
            // You can display the message in the UI
        });

        avatar.off(StreamingEvents.AVATAR_END_MESSAGE).on(StreamingEvents.AVATAR_END_MESSAGE, (message) => {
            console.log('Avatar end message:', message);
            // Handle the end of the avatar's message, e.g., indicate the end of the conversation
        });

        avatar.off(StreamingEvents.USER_TALKING_MESSAGE).on(StreamingEvents.USER_TALKING_MESSAGE, (message) => {
            console.log('User talking message:', message);
            // Handle the user's message input to the avatar
        });
        avatar.off(StreamingEvents.USER_END_MESSAGE).on(StreamingEvents.USER_END_MESSAGE, (message) => {
            console.log('User end message:', message);
            // Handle the end of the user's message, e.g., process the user's response
        });

        avatar.off(StreamingEvents.USER_START).on(StreamingEvents.USER_START, (event) => {
            console.log('User has started interaction:', event);
            // Handle the start of the user's interaction, such as activating a listening indicator
        });

        avatar.off(StreamingEvents.USER_STOP).on(StreamingEvents.USER_STOP, (event) => {
            console.log('User has stopped interaction:', event);
            // Handle the end of the user's interaction, such as deactivating a listening indicator
        });

        avatar.off(StreamingEvents.USER_SILENCE).on(StreamingEvents.USER_SILENCE, () => {
            console.log('User is silent');
        });

        avatar.off(StreamingEvents.STREAM_READY).on(StreamingEvents.STREAM_READY, (event) => {
            console.log('Stream is ready:', event.detail);
            // Use event.detail to attach the media stream to a video element, for example
        });
        avatar.off(StreamingEvents.STREAM_DISCONNECTED).on(StreamingEvents.STREAM_DISCONNECTED, () => {
            console.log('Stream has been disconnected');
            // Handle the disconnection, e.g., clean up the UI or try to reconnect the session
        });
 

    }


    async function grab() {
        try {
            await updateToken();
        } catch (err) {
            console.error('Error grab:', err);
        }

        if (!avatar.current) {
            setDebug('Avatar API is not initialized');
            return;
        }


        addEventsOnAvatar(avatar.current)

        let sessionData = null;
    /*    { 
    config: {
        quality: AvatarQuality.Medium,
        avatarName: avatarId,
        voice: {
            rate: 1.5,
            emotion: VoiceEmotion.EXCITED,
            model: ElevenLabsModel.eleven_flash_v2_5,
        },
        language: "en",
    }
            
    }*/
    
        try {
            sessionData = await avatar.current.createStartAvatar({
                newSessionRequest: {
                    quality: "medium",
                    avatarName: avatarId,
                    voice: {
                        voiceId: voiceId,
                        rate: 1.0,
                        pitch: 1.0,
                        emotion: "neutral"
                    },
                    interrupt: true,
                    activityIdleTimeout: 120
                }

            });

        } catch (error) {
            console.error('Error starting avatar session:', error.response?.data || error.message);
            setDebug(`Error: ${error.response?.data || error.message}`);
        }

        try {
            if (sessionData) {
                setData(sessionData);
                setStream(avatar.current.mediaStream);
            }
           

        } catch (error) {
            console.error('Error starting avatar session:', error.response?.data || error.message);
            setDebug(`Error: ${error.response?.data || error.message}`);
        }


        try {
            setPlay(true);
        } catch (error) {
            console.error('Error starting avatar session:', error.response?.data || error.message);
            setDebug(`Error: ${error.response?.data || error.message}`);
        }

    }


    async function updateVideo(vObj) {
        setVideoObj(vObj)        
    }

    async function handleSpeak(value) {
        
        console.log("handleSpeak:   ", initialized, value); 
        
        if (!initialized || !avatar.current) {
            setDebug('Avatar API not initialized');
            return;
        }
         
      //  setPlay(true); 
        await avatar.current.speak({
            taskRequest: {
                text: value,
                sessionId: data?.sessionId
            }
        }).catch((e) => {
            setDebug(e.message);
        });
        
        
        if (videoObj) {
            videoObj.events.playPauseAvatar('play');
            videoObj.events.muteUnmuteAvatar('unmute');
        }
 
    }

    useEffect(() => {
        return () => {
            avatar.current?.stop();
        };
    }, []);


    return (
        <AppContext.Provider value={{ grab, setAvatarId, setVoiceId, avatarId, voiceId, initialized, setDebug, avatar, data, fetchAccessToken, setInitialized, setStream, stream, play,handleSpeak, updateVideo }}>
            {children}
        </AppContext.Provider>
    )
}

export {AppContext,AppProvider};